import { useState } from 'react';
import { PANEL_GUIDE } from './_barrel.js';


        // Slim, collapsible "How this works" explainer that sits at the top of a
        // panel (just under its header). Reads its copy from PANEL_GUIDE by id so
        // every panel's guidance lives in one place; callers can also pass
        // title/intro/steps inline to override. Starts collapsed (there are many
        // panels — an always-open explainer on each would be noise) and remembers
        // the analyst's choice per id in localStorage.
        //
        // Renders nothing if there's no copy for the id, so dropping
        // <PanelHowTo id="..."/> into a panel is always safe.
        function PanelHowTo({ id, title, intro, steps, defaultOpen = false }) {
            const guide = (id && PANEL_GUIDE[id]) || {};
            const heading = title || guide.title || 'How this works';
            const introHtml = intro || guide.intro;
            const stepList = steps || guide.steps || [];

            // Hooks must run on every render (rules-of-hooks): call useState BEFORE
            // any early return, then bail out below if there's no copy to show.
            const key = 'veil_panelhowto_' + (id || heading);
            const [open, setOpen] = useState(() => {
                try {
                    const v = localStorage.getItem(key);
                    return v === null ? defaultOpen : v === 'open';
                } catch (e) { return defaultOpen; }
            });
            const toggle = () => setOpen(o => {
                const n = !o;
                try { localStorage.setItem(key, n ? 'open' : 'closed'); } catch (e) { /* ignore */ }
                return n;
            });

            // Nothing to show for this id — render nothing (safe to drop anywhere).
            if (!introHtml && stepList.length === 0) return null;

            return (
                <div className="panel-howto">
                    <button type="button" className="panel-howto-toggle" onClick={toggle} aria-expanded={open}>
                        <span className="panel-howto-chevron" aria-hidden="true">{open ? '▾' : '▸'}</span>
                        {heading}
                    </button>
                    {open && (
                        <div className="panel-howto-body">
                            {introHtml && <p dangerouslySetInnerHTML={{ __html: introHtml }} />}
                            {stepList.length > 0 && (
                                <ol>
                                    {stepList.map((s, i) => <li key={i} dangerouslySetInnerHTML={{ __html: s }} />)}
                                </ol>
                            )}
                        </div>
                    )}
                </div>
            );
        }

export { PanelHowTo };
